import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinimise = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.33333 16.6667V11.6667H3.33333M8.33333 11.6667L2.5 17.5M11.6667 3.33333V8.33333H16.6667M11.6667 8.33333L17.5 2.5",
		stroke: "white",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMinimise;
